var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-drawer',{attrs:{"title":_vm.title,"width":_vm.width,"placement":"right","closable":false,"destroyOnClose":"","visible":_vm.visible},on:{"close":_vm.close}},[_c('HomeIndex',{on:{"close":_vm.close}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }